import styled from "styled-components";

export const CloseButton = styled.div`
  width: 20px;
  height: 20px;
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
`;
